import React from 'react';

// Biztimize gauge mark (Final · Gauge logo). `tile` draws it on the navy
// rounded square used on light backgrounds; without it the bare gauge sits
// directly on a navy surface.
const NAVY = '#2C3E50';
const CORAL = '#FF7F50';
const YELLOW = '#FFC93C';
const GREEN = '#22D36B';

const BiztimizeMark = ({ size = 64, tile = false, title = 'Biztimize mark' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    role="img"
    aria-label={title}
    style={{ display: 'block' }}
  >
    {tile && <rect width="64" height="64" rx="14" fill={NAVY} />}
    <path
      d="M16.73 49.27 A21.6 21.6 0 1 1 47.27 49.27"
      fill="none"
      stroke="#FFFFFF"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
    <path d="M19.98 46.02 A17 17 0 0 1 19.37 22.62" fill="none" stroke={CORAL} strokeWidth="6" />
    <path d="M20.62 21.37 A17 17 0 0 1 43.38 21.37" fill="none" stroke={YELLOW} strokeWidth="6" />
    <path d="M44.63 22.62 A17 17 0 0 1 44.02 46.02" fill="none" stroke={GREEN} strokeWidth="6" />
    <path d="M46.57 28.70 L32.58 35.60 L28.71 35.20 L31.42 32.40 Z" fill="#FFFFFF" />
    <circle cx="32" cy="34" r="3" fill="#FFFFFF" />
    <circle cx="32" cy="34" r="1.1" fill={NAVY} />
  </svg>
);

export default BiztimizeMark;
